module.exports = __webpack_public_path__ + "img/pic_5.ab368828.jpg";